import { render } from "./Home.vue?vue&type=template&id=70db07d8&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=70db07d8&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-70db07d8"

export default script